module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "animated-area"
  }, [(!mainImage) ? _h('section', {
    staticClass: "hero is-fullheight main-background"
  }, [_h('div', {
    staticClass: "hero-body"
  }, [_h('div', {
    staticClass: "container"
  }, [_h('center', [_m(0), " ", _h('router-link', {
    staticClass: "button is-danger is-medium",
    attrs: {
      "to": "/"
    }
  }, ["Back"])])])])]) : _e(), " ", _m(1), " ", _m(2), " ", _h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (isAnimating),
      expression: "isAnimating"
    }],
    attrs: {
      "id": "particle_wrapper"
    }
  }), " ", _h('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (showFinal),
      expression: "showFinal"
    }],
    attrs: {
      "id": "final_image"
    }
  }), " ", _h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (showButtons),
      expression: "showButtons"
    }],
    staticClass: "button-wrapper"
  }, [(isMobile) ? _h('center', [_m(3)]) : _e(), " ", _h('center', [_h('a', {
    staticClass: "button is-light is-medium",
    on: {
      "click": setupParticleWrapper
    }
  }, ["Replay"]), " ", (!isMobile) ? _h('a', {
    staticClass: "button is-success is-medium",
    attrs: {
      "download": "mosaic.png",
      "id": "download_button"
    }
  }, ["Download"]) : _e(), " ", _h('router-link', {
    staticClass: "button is-danger is-medium",
    attrs: {
      "to": "/"
    }
  }, ["Restart"])])])])
}},staticRenderFns: [function (){with(this) {
  return _h('p', {
    staticClass: "instruction warning-message"
  }, ["Main image has not been selected!"])
}},function (){with(this) {
  return _h('canvas', {
    attrs: {
      "id": "canvas"
    }
  })
}},function (){with(this) {
  return _h('canvas', {
    attrs: {
      "id": "helper"
    }
  })
}},function (){with(this) {
  return _h('p', {
    staticClass: "instruction"
  }, ["Touch and hold to save image"])
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-013349db!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlayAnimation.vue
// module id = 122
// module chunks = 2